module.exports = __webpack_public_path__ + "ccede779246907ffc1e94775baa0bdb8.png";